import { createContext, useContext, useState } from "react";
import SideDrawer from "./SideDrawer/SideDrawer";
import FilterResumeList from "./filterResumeList";
import { useTranslation } from "react-i18next";

const SideDrawerSearchContext = createContext();

export default function SideDrawerSearch({
  children,
  searchForm,
  onClearFilters,
  onRemoveFilter,
  submitSearch,
  direction
}) {
  const [isOpen, setIsOpen] = useState();
  const [filterObject, setFilterObject] = useState({});
  let { t } = useTranslation();
  
  function clearFilters() {
    setFilterObject({});
    setIsOpen(false);
    onClearFilters && onClearFilters();
  }

  function search(searchObject) {
    setIsOpen(false);
    submitSearch && submitSearch(searchObject);
  }

  function onChangeFilters (key, value, checked) {
    if(key === "recommended"){
      if(checked === true){
        setFilterObject({...filterObject, [key]:value});
      }else{
        let _filterObject = {...filterObject};
        delete _filterObject[key];
        setFilterObject(_filterObject);
      }
    }else if(key.key === "availabilityStatus" || key.key === "skills"){
      if(key.value){
        setFilterObject({...filterObject, [key.value]:key.value});
      }else{
        let _filterObject = {...filterObject};
        delete _filterObject[key.value];
        setFilterObject({...filterObject, [key.value]:key.value});
      }
    }else if(key.key === "favorites"){
      if(key.checked === true){
        setFilterObject({...filterObject, [key.value]:key.value});
      }else{
        let _filterObject = {...filterObject};
        delete _filterObject[key];
        setFilterObject({...filterObject});
      }
    }else if(key.key === "rating"){
      if(key.value !== "rating 0"){
        setFilterObject({...filterObject, [key.value]:key.value});
      }else{
        let _filterObject = {...filterObject};
        delete _filterObject[key.value];
        setFilterObject({...filterObject});
      }
    }else if(key.key === "startingDate" || key.key === "endingDate"){
      setFilterObject({...filterObject, [key.value]:key.value});
    }else{
      if(value){
        setFilterObject({...filterObject, [key]:value});
      }else{
        let _filterObject = {...filterObject};
        delete _filterObject[key];
        setFilterObject(_filterObject);
      }
    }
  }
  
  return (
      <SideDrawerSearchContext.Provider 
        value={{
          onChangeFilters,
        }}>
      <div className="row">
        <div className="col-11">
          <FilterResumeList
            filterObject={filterObject}
            setFilterObject={setFilterObject}
            onRemoveFilter={onRemoveFilter}
            onClearAll={clearFilters}
          />
        </div>
        <div className=" col text-end">
          <a href="#!" onClick={() => setIsOpen(!isOpen)} className="me-5">
            Filters
          </a>
        </div>
      </div>
      <div>{children}</div>
      <SideDrawer
        isOpen={isOpen}
        direction={direction || "right"}
        cancelBbutton={clearFilters}
        cancelButtonLabel={t("Clear")}
        submitButtonLabel={t("Search")}
        submitButton={search}
        onOverlayClick={() => setIsOpen(false)}
      >
        <div className="p-4">{searchForm && searchForm()}</div>
      </SideDrawer>
      </SideDrawerSearchContext.Provider>
  );
}

export function useSideDrawerSearch(){
  return useContext(SideDrawerSearchContext);
}